/** @flow */
const data = {
  email: "demo@themostaza.com",
  password: "demo"
};

const responses = {
  POST: {
    "401": "Invalid Email or password."
  }
};

export default {
  login: { responses, data }
};
